module.exports = __webpack_public_path__ + "img/konfigurasi_kargo.860fd477.svg";